export default "__VITE_ASSET__C5KHSC2J__"